import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  RejectBatchPaymentRepository,
  PaymentActionResponse,
} from "features/stock-ordering/data/stock-ordering.repository";
import { RejectBatchPaymentParam } from "features/stock-ordering/core/stock-ordering.params";

export enum RejectBatchPaymentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: RejectBatchPaymentState;
  message: string;
}

const initialState: InitialState = {
  status: RejectBatchPaymentState.initial,
  message: "",
};

export const rejectBatchPayment = createAsyncThunk(
  "rejectBatchPayment",
  async (param: RejectBatchPaymentParam, { rejectWithValue }) => {
    try {
      const response: PaymentActionResponse =
        await RejectBatchPaymentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  },
);

export const rejectBatchPaymentSlice = createSlice({
  name: "rejectBatchPayment",
  initialState,
  reducers: {
    resetRejectBatchPayment: (state) => {
      state.status = RejectBatchPaymentState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(rejectBatchPayment.pending, (state) => {
        state.status = RejectBatchPaymentState.inProgress;
      })
      .addCase(rejectBatchPayment.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = RejectBatchPaymentState.success;
          state.message = action.payload.message;
        }
      })
      .addCase(rejectBatchPayment.rejected, (state, action) => {
        state.status = RejectBatchPaymentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectRejectBatchPayment = (state: RootState) =>
  state.rejectBatchPayment;
export const { resetRejectBatchPayment } = rejectBatchPaymentSlice.actions;
export default rejectBatchPaymentSlice.reducer;
